<div class="profile-address-list">

    @if (addressesList.length > 0) {
    @for (address of addressesList; track $index) {
    <div class="profile-address-list-item">

        <div class="profile-address-list-item-option">
            {{ address.type | translate }}
        </div>

        <div class="profile-address-list-item-value" [title]="address.value">
            {{address.value}}
        </div>

    </div>
    }
    } @else {
    <div class="profile-address-list-empty">
        {{ 'ADDRESS_LIST.TITLES.EMPTY' | translate }}
    </div>
    }

</div>